import React, { useState, useEffect } from "react"
import { Layout, Menu, Select } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import Sidebar from "../../layout/sidebar";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";

const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const PostSuggestions
    = () => {

        // modale
        const [modal1Open, setModal1Open] = useState(false)
       
        const navigate = useNavigate()



        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Inner Circle</h1>
                            <Breadcrumb separator=">">

                                <Breadcrumb.Item>
                                    <Link to="/innercircle"> Inner Circle </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {appconstant.postSuggestions }
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className="add-new-button">
                            <button onClick={() => setModal1Open(true)}>Post Suggestions </button>
                        </div>
                    </div>


                    <div className="content-e outter-space">


                        <div class="bg-gradient-primary inner-meditation-border">
                            <input type="text" className="iocn-search  search-bar" placeholder="Search " />

                        </div>


                        <div className="inner-circle outer-meditation-border inner-circle-bott">
                            <div className="create-inner-section ">


                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>


                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>

                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>


                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>


                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>


                                <div className="create-entertainment-circle meditation-inner-padding">
                                    <div className=" meditation-flex">
                                        <div className="medita-image">
                                            <img src={images.gratitude} alt="gratitude" />
                                        </div>
                                        <div className="righ-side-dotes">
                                            <img src={images.horizontalDots} alt="horizontalDots" />
                                        </div>
                                    </div>

                                    <div className="meditation-heading">
                                        <h1>Gratitude Gala </h1>

                                        <p>Post a photo, quote, or description of a mindful moment.</p>

                                    </div>

                                </div>
                     

                            </div>

                        </div>


                    </div>




                    {/* create inner circle */}
                    <Modal
                        title=""
                        className="modal-update"
                        centered
                        visible={modal1Open}
                        closable={true}
                        onCancel={() => setModal1Open(false)}
                        footer={false}
                        width={600}  >
                        <div className="add-user-popup">
                            <div className="modal-add-user">
                                <h1>Post Suggestions </h1>
                            </div>

                            <div className="description-inner-circle">
                                <div className="wrapper_line">
                                    <div className="form-group">
                                        <label>{appconstant.title}</label>
                                        <Textfiled
                                            className='form-control'
                                            type='text'
                                            placeholder='Enter Title'
                                        />
                                    </div>

                                    <div className="form-group">
                                        <div className="textarea-label">
                                            <label>{appconstant.detail}</label>
                                            <p>0/500</p>
                                        </div>
                                        <textarea
                                            rows="7" cols="50"
                                            className='form-control-textarea'
                                            type='textarea'
                                            placeholder='Enter Detail here' />
                                    </div>
                                </div>
                            </div>


                            <div className="add-sugg-activity post-sug-margin">
                           
                                <div className="click-to-upload label-top-space">
                                   <label>Upload Icons</label>
                                    <div className="upload-file new-up-file label-less-margin">
                                        <div className="upload-center-text add-up-activity">
                                            <p><span><img src={images.upload} alt="upload" /></span> Click here to upload</p>
                                        </div>

                                        <p className="image-disp">File Format: .JPEG, .PNG</p>

                                    </div>

                                </div>
                            </div>

                            <div className="click-to-upload">
                                <div className="add-activity-button">
                                    <button>Add Activity</button>
                                </div>
                            </div>





                        </div>
                    </Modal>





                </div>








            </div>
        )
    }
export default PostSuggestions

